import defaults from './defaults';

export const environment = {
  ...defaults,
  production: true,
  apiUrl: 'https://dev-api.pf-flightpath.com'
};
